import React from "react";
import { Router } from "@reach/router";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import DefaultLayout from "../layouts/default";
import OrgLayout from "../layouts/org";

import FeedbackView from "../views/Feedback";
import HomeView from "../views/Home";
import SettingsView from "../views/Settings";
import TeamView from "../views/Team";
import SuggestionsView from "../views/Suggestions";

const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);

export default () => (
    <Router>
        <DefaultLayout path="/">
            <HomeView path="/" />
        </DefaultLayout>

        <OrgLayout path="/:code">
            <SuggestionsView path="/" />
            <SuggestionsView path="/feedback" />
            <FeedbackView path="/feedback/:id" />
            <TeamView path="/team" />
            <Elements stripe={ stripePromise } path="/settings">
                <SettingsView path="/" />
            </Elements>
        </OrgLayout>
    </Router>
);
